export { default } from './ScbQr'



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/ScbQr/index.js